import * as React from 'react';

import { PropertySpaceDetails } from '@shared-ui/lodging-property-offers';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const SpaceDetailsWrapper: React.FC<SharedUiWrapperProps & { className?: string }> = ({ inputs, className }) => (
  <PropertySpaceDetails inputs={inputs} className={className} skipSsr={true} />
);
SpaceDetailsWrapper.displayName = 'SpaceDetailsWrapper';

export const SharedUiSpaceDetailsWrapper = withSharedUiPropertyOffers(SpaceDetailsWrapper);
